import React, { useEffect, useRef, useState } from "react";
import { context } from "./context";
import LogOutModal from "../components/common/logOutModal/LogOutModal";
import { getApi } from "../services/api/globalApi";
import Cookies from "js-cookie";

const MainContext = ({ children }) => {
  const [show, setShow] = useState(false);
  const [utils, setUtils] = useState(false);
  const [user, setUser] = useState(null);

  const logOutModal = useRef();

  const showLogutModal = () => {
    logOutModal.current.showModal();
  };

  const getUser = async () => {
    const path = "users/me";
    try {
      const response = await getApi({ path });
      setUser(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getUtils = async () => {
    const path = "admin/utils/constants";
    try {
      const response = await getApi({ path });
      setUtils(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Cookies.get("liResponse")) {
      getUser();
    }
  }, []);

  useEffect(() => {
    getUtils();
  }, []);

  return (
    <context.Provider
      value={{
        show,
        setShow,
        showLogutModal,
        utils,
        user,
        getUser,
        getUtils
      }}
    >
      {children}
      <LogOutModal ref={logOutModal} />
    </context.Provider>
  );
};

export default MainContext;
